<template>
  <div>
    <input ref="input" type="tel" autocomplete="off" :value="formattedValue" @keydown="handleKeydown"
      @input="updateValue" @mousedown="preventClick" />

  </div>
</template>

<script>
  export default {
    name: "CurrencyInput",
    props: {
      value: {
        type: [String, Number],
        default: "0.00"
      }
    },
    data() {
      return {
        // Flag to check if it's the first input
        firstInput: true
      };
    },
    computed: {
      formattedValue() {
        let value = parseFloat(this.value || "0");
        return value.toLocaleString('pt-br', { minimumFractionDigits: 2 });
      }
    },


    methods: {
      preventClick(event) {
        event.preventDefault();
      },

      updateValue(event) {
        let inputValue = event.target.value.trim();

        // Substitui apenas pontos e vírgulas que não sejam seguidos de dígitos (para evitar erros)
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) / 100;

        if (!isNaN(numericValue)) {
          this.$emit('input', numericValue);
        }
      }
      ,

      // Handles keydown events to control formatting and prevent unwanted characters
      handleKeydown(event) {
        this.$emit('keydown', event);
        const { key } = event;

        if (this.value === '0.00') this.$emit('input', 0);

        if (this.firstInput) {
          event.preventDefault();
          this.firstInput = false;
          this.$emit('input', `0.0${key}`);
        }

        if (key === "Backspace") {
          event.preventDefault();
          return this.$emit('input', 0);
        }

        if (!/\d/.test(key)) {
          this.firstInput = true;
          return event.preventDefault();
        }
      },

      // Ensures the input field stays focused
      forceFocus() {
        const inputEl = this.$refs.input;
        if (inputEl && document.activeElement !== inputEl) {
          inputEl.focus();
        }
      }
    },
    mounted() {
      this.forceFocus();
      this.focusInterval = setInterval(this.forceFocus, 100);
    },
    beforeDestroy() {
      clearInterval(this.focusInterval);
    }
  };
</script>

<style scoped>
  input {
    background: transparent;
    border: none;
    color: inherit;
    font-size: 60px;
    font-weight: bold;
    width: auto;
    /* Alterado de 100% para auto */
    max-width: 200px;
    /* Limita o tamanho do input */
    outline: none;
    caret-color: transparent;
    cursor: none;
    text-align: center;
    /* Centraliza o texto digitado */
    display: block;
    /* Garante que respeite o tamanho definido */
    margin: 0 auto;
    /* Centraliza o elemento */
  }
</style>
